import { jsx as be } from "react/jsx-runtime";
import { isValid as ke, addDays as xe, subDays as Re } from "date-fns";
import { useRef as s, useState as u, useCallback as n, useMemo as N, useEffect as ve, createContext as Ce, useContext as Ie } from "react";
import { labelSuggestion as V } from "./index.es2483.js";
import { getLastDateRefOfMonth as Le, focusFirstElement as b } from "./index.es2484.js";
const Oe = { value: [null, null] }, Se = /* @__PURE__ */ new Date(), Me = Ce(void 0), $e = ({ children: x, context: pe }) => {
  const Y = s(!1), [q, Pe] = u(!1), k = s(null), C = s(null), I = s(null), L = s(null), z = s([]), d = s(!1), [B, f] = u(null), [G, i] = u(null), O = s([]), S = s([]), R = n((e) => {
    const a = (e === "left" ? O.current : S.current).find((D) => (D == null ? void 0 : D.textContent) === "1");
    a && a.focus();
  }, []), J = n((e) => {
    const t = e === "left" ? O.current : S.current, a = Le(t);
    a && a.focus();
  }, []), K = n(() => {
    k.current && b(k.current);
  }, []), Q = n(() => {
    C.current && b(C.current);
  }, []), v = n(() => {
    I.current && b(I.current);
  }, []), M = n(() => {
    L.current && b(L.current);
  }, []), U = n((e) => {
    d.current = e, e || (d.current = !0, setTimeout(() => {
      d.current = !1;
    }, 150));
  }, []), p = n((e = 0) => {
    var t;
    (t = z.current[e]) == null || t.focus();
  }, []), {
    endDate: y,
    maxDate: T,
    maxMonth: E,
    minDate: F,
    startDate: A,
    placeholder: m,
    weekStartingDay: W,
    extraInitialData: g,
    onChange: P,
    onClose: w,
    ...X
  } = pe, {
    minDate: Z,
    maxDate: _,
    maxMonth: ee,
    startDate: l,
    endDate: c
  } = N(
    () => ({
      minDate: F ? new Date(F) : void 0,
      maxDate: T ? new Date(T) : void 0,
      maxMonth: E ? new Date(E) : void 0,
      startDate: A ? new Date(A) : void 0,
      endDate: y ? new Date(y) : void 0
    }),
    [F, T, E, A, y]
  ), H = N(() => ke(c) ? {
    value: [l, c],
    ...g
  } : Oe, [c, l, g]), [r, te] = u(H), ne = s(r);
  ve(() => {
    te(H);
  }, [H]);
  const [ae, se] = u(
    g && g.activePanel ? g.activePanel : "date-range"
  ), [re, oe] = u(
    V(l, c, m, r)
  ), [ce, $] = u(!1), le = n(
    (e) => {
      Y.current = !0, ne.current = e, $(!1), oe(
        V(
          e.value[0],
          e.value[1],
          m,
          r
        )
      ), P == null || P(e);
    },
    [P, m, r]
  ), ue = n(() => {
    $((e) => !e);
  }, []), fe = n(
    (e) => {
      e == null || e.preventDefault(), w == null || w(e), setTimeout(() => {
        $(!1);
      }, 150);
    },
    [w]
  ), ie = n((e, t) => {
    se(e), t && t();
  }, []), De = n(
    (e, t, a, D) => {
      let o;
      switch (t) {
        case "up":
          o = Re(e, 7);
          break;
        case "down":
          o = xe(e, 7);
          break;
        case "left":
          o = Re(e, 1);
          break;
        case "right":
          o = xe(e, 1);
          break;
        default:
          return;
      }
      const j = D.find(
        (h) => h.$date.getTime() === o.getTime()
      );
      if (j && !j.disabled && j.inCurrentMonth) {
        a === "left" ? (f(o), i(null)) : (i(o), f(null));
        return;
      }
      if (t === "left" && a === "right") {
        i(null), f(o);
        return;
      } else if (t === "right" && a === "left") {
        f(null), i(o);
        return;
      }
      const de = D.filter((h) => h.inCurrentMonth), me = de.findIndex(
        (h) => h.$date.getTime() === e.getTime()
      ), ge = me === 0, he = me === de.length - 1;
      if (a === "left") {
        if (he && (t === "down" || t === "right")) {
          R("right");
          return;
        }
        if (ge && (t === "left" || t === "up")) {
          v();
          return;
        }
      }
      if (a === "right") {
        if (ge && t === "up") {
          M();
          return;
        }
        if (he && (t === "right" || t === "down")) {
          p(0);
          return;
        }
      }
    },
    [
      R,
      v,
      M,
      p,
      f,
      i
    ]
  ), we = N(
    () => ({
      minDate: Z,
      maxDate: _,
      maxMonth: ee,
      startDate: l,
      endDate: c,
      label: re,
      isOpen: ce,
      activePanel: ae,
      TODAY: Se,
      selectedRangeData: r,
      weekStartingDay: W,
      collapsedIsOpen: q,
      onToggle: ue,
      onApply: le,
      setActivePanel: se,
      onPanelSelect: ie,
      onClose: fe,
      setSelectedRangeData: te,
      setCollapsedIsOpen: Pe,
      // Menu focus management
      leftMenuRef: k,
      rightMenuRef: C,
      rangeDropdownOpenRef: d,
      focusLeftMenu: K,
      focusRightMenu: Q,
      focusLeftDateRangeHeader: v,
      focusRightDateRangeHeader: M,
      setRangeDropdownOpen: U,
      // Arrow key navigation
      focusedDateLeft: B,
      focusedDateRight: G,
      setFocusedDateLeft: f,
      setFocusedDateRight: i,
      handleDateNavigation: De,
      // Day matrix focus management
      leftPanelDayRefs: O,
      rightPanelDayRefs: S,
      leftDateRangeHeaderRef: I,
      rightDateRangeHeaderRef: L,
      focusFirstDateInPanel: R,
      focusLastDateInPanel: J,
      // Footer actions
      footerActionRefs: z,
      focusFooterAction: p,
      ...X
    }),
    [
      Z,
      _,
      ee,
      l,
      c,
      re,
      ce,
      ae,
      r,
      W,
      q,
      ue,
      le,
      ie,
      fe,
      K,
      Q,
      v,
      M,
      U,
      B,
      G,
      d,
      De,
      R,
      J,
      p,
      X
    ]
  );
  return ve(() => {
    !Y.current && ne.current === r && oe(
      V(
        l,
        c,
        m,
        r
      )
    );
  }, [l, c, m, r]), /* @__PURE__ */ be(Me.Provider, { value: we, children: x });
}, je = () => {
  const x = Ie(Me);
  if (!x)
    throw new Error("useDatePicker must be used within a DatePickerProvider");
  return x;
};
export {
  $e as DatePickerProvider,
  je as useDatePicker
};
//# sourceMappingURL=index.es851.js.map
